var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1296 1.9303C5.98964 1.9303 2.56958 5.0303 2.06958 9.0403C2.43958 8.8903 2.83964 8.8103 3.25964 8.8103C4.29964 8.8103 5.13965 9.65031 5.13965 10.6903V15.6903C5.13965 16.7303 4.29964 17.5703 3.25964 17.5703C1.52964 17.5703 0.139648 16.1703 0.139648 14.4503V10.0703C0.139648 4.55031 4.61965 0.0703125 10.1396 0.0703125C15.6596 0.0703125 20.1396 4.55031 20.1396 10.0703V14.4503C20.1396 16.1803 18.7397 17.5703 17.0197 17.5703C15.9797 17.5703 15.1396 16.7303 15.1396 15.6903V10.6903C15.1396 9.65031 15.9797 8.8103 17.0197 8.8103C17.4397 8.8103 17.8396 8.8903 18.2096 9.0403C17.7096 5.0303 14.2897 1.9303 10.1497 1.9303H10.1296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallW);
export default __webpack_public_path__ + "static/media/call_w.059a660d37e407e41f3c7aa6992e41bb.svg";
export { ForwardRef as ReactComponent };